import { departmentDashboard } from '../../actions/constant';

const { GET_DEPARTMENT_PTO_FAILURE, GET_DEPARTMENT_PTO_SUCCESS, GET_DEPARTMENT_PTO_LOADING } =
  departmentDashboard;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getDepartmentPTOReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DEPARTMENT_PTO_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload.data,
        loading: false,
      };
    }

    case GET_DEPARTMENT_PTO_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_DEPARTMENT_PTO_LOADING:
      return {
        loading: true,
      };

    default:
      return state;
  }
};
